import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

export default function GroupsSinglePageInner(props) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    return props.children({ mobile, theme });
}
